function getOrdinal(player) {
  return player.tournamentOrdinal;
}

function compare(a, b) {
  const pts = b.tournamentPoints - a.tournamentPoints;
  if (pts !== 0) return pts;
  const diff = b.goalDiff - a.goalDiff;
  if (diff !== 0) return diff;
  return getOrdinal(a) - getOrdinal(b);
}

export function rankPlayers(players) {
  const present = [];
  const absent = [];
  for (const p of players) {
    if (p.present) {
      present.push(p);
    } else {
      absent.push(p);
    }
  }
  present.sort(compare);
  absent.sort(compare);
  let place = 1;
  const mapped = present.map((p, i) => {
    if (i > 0 && (p.tournamentPoints !== present[i - 1].tournamentPoints || p.goalDiff !== present[i - 1].goalDiff || getOrdinal(p) !== getOrdinal(present[i - 1]))) {
      place = i + 1;
    }
    return { player: p, place };
  });
  for (const p of absent) {
    mapped.push({ player: p, place: null });
  }
  return mapped;
}
